<ion-row [ngClass]="useDefaultStyling ? 'row-with-fixed-col-title--default' : ''" class="{{ class }}">
    <ion-col [size]="fixedColSize" class="flex align-items-start justify-content-space-between">
        <p *ngIf="title">{{ title }}</p>
        <p *ngIf="separator">{{ separator }}</p>
        <ng-content select="title-content"></ng-content>
    </ion-col>
    <ion-col class="text-dark font-weight-medium">
        <ng-content></ng-content>
    </ion-col>
</ion-row>
